import { AgentComponentMode, type AgentComponent } from '@reach/shared-types/agent-components';
import { Lock, ToggleRight } from 'lucide-react';
import styles from './TenantPreviewItem.module.css';

interface TenantPreviewItemProps {
  component: AgentComponent;
  partnerName: string | undefined;
}

export const TenantPreviewItem = ({ component, partnerName }: TenantPreviewItemProps) => {
  const { name, tenantName, tenantDescription, mode } = component;
  const componentIsLocked = mode === AgentComponentMode.ALWAYS_ON;
  const switchIsOn = mode === AgentComponentMode.DEFAULT_ON;
  const switchLabel = switchIsOn ? 'On' : 'Off';
  const setByLabel = partnerName ? `Set by ${partnerName}` : 'Always on';
  const defaultOwner = partnerName ? `${partnerName} default` : 'Default';
  const defaultLabel = `${defaultOwner}: ${switchLabel}`;
  const displayName = tenantName || name;

  return (
    <li className={styles.tenantPreviewItem}>
      <h4>{displayName}</h4>
      {tenantDescription && <p>{tenantDescription}</p>}
      {componentIsLocked ? (
        <>
          <span className={styles.state}>Always on</span>
          <div className={styles.notes}>
            <span className={styles.setBy}>
              <Lock aria-hidden="true" />
              {setByLabel}
            </span>
          </div>
        </>
      ) : (
        <>
          <span className={styles.state} data-on={switchIsOn}>
            {switchLabel}
            <span className={styles.switch} aria-hidden="true" />
          </span>
          <div className={styles.notes}>
            <span className={styles.tenantChoice}>
              <ToggleRight aria-hidden="true" />
              You can turn this on or off
            </span>
            <span>{defaultLabel}</span>
          </div>
        </>
      )}
    </li>
  );
};
